export enum DesktopScrollPos {
    start = 'start',
    end = 'end',
    middle = 'middle',
}
